import { config } from 'env_def';
import { api } from '../../../api/api';
import { apis } from '../../../config';
import { constHttpCanceledToken } from '../../../api/data/http';
import { locationHelper } from '@/api/util/location_helper';
class ConvertApiImpl {
    constructor() {
        this.name = apis.convertApiImpl;
        this.http = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    async convertMailAttachment2Doc(params) {
        const user = this.systemApi.getCurrentUser();
        const res = await this.http.post(this.systemApi.getUrl('covertMailAttachment2Doc'), Object.assign(Object.assign({}, params), { uid: user === null || user === void 0 ? void 0 : user.id, sid: user === null || user === void 0 ? void 0 : user.sessionId }), { noEnqueue: true });
        const data = res.data;
        return data.data.taskId;
    }
    async convertFile2Doc(fileId, dirId) {
        const res = await this.http.post(this.systemApi.getUrl('convertFile2Doc'), { fileId, dirId }, {
            noEnqueue: true,
            timeout: 1000 * 60 * 2,
        });
        const data = res.data;
        return data.data.taskId;
    }
    async convertPersonalFile2Doc(fileId, dirId) {
        const res = await this.http.post(this.systemApi.getUrl('convertPersonalFile2Doc'), { fileId, dirId }, {
            noEnqueue: true,
            timeout: 1000 * 60 * 2,
        });
        const data = res.data;
        return data.data.taskId;
    }
    async getMailAttachmentDocCovertStatus(taskId) {
        const res = await this.http.get(this.systemApi.getUrl('getMailAttachmentDocCovertStatus'), { taskId }, { noEnqueue: true });
        const data = res.data;
        return data.data;
    }
    async importDoc(file, docType, fileName, dirId, getCancelFn = () => { }) {
        const formdata = new FormData();
        formdata.append('file', file);
        formdata.append('docType', docType);
        formdata.append('fileName', fileName || file.name);
        formdata.append('dirId', `${dirId}`);
        const res = await this.http
            .post(this.systemApi.getUrl('importDoc'), formdata, {
            noEnqueue: true,
            contentType: 'arraybuffer',
            headers: {
                contentType: 'multipart/form-data',
            },
            timeout: 1000 * 60 * 2,
            operator: (handler) => {
                getCancelFn(handler.bind(null, 'abort'));
            },
        })
            .catch((err) => {
            if (typeof err === 'string') {
                throw new Error(err);
            }
            if (err.message.includes(constHttpCanceledToken)) {
                throw new Error('cancelled');
            }
            throw err;
        });
        const data = res.data;
        return data.data.taskId;
    }
    async checkConvertTask(taskId) {
        const res = await this.http.get(this.systemApi.getUrl('checkConvertTask'), { taskId }, {
            noEnqueue: true,
            timeout: 1000 * 60 * 2,
        });
        const data = res.data;
        return data.data;
    }
    async importPersonalDoc(file, docType, fileName, dirId, getCancelFn = () => { }) {
        const formdata = new FormData();
        formdata.append('file', file);
        formdata.append('docType', docType);
        formdata.append('fileName', fileName || file.name);
        formdata.append('dirId', `${dirId}`);
        const res = await this.http
            .post(this.systemApi.getUrl('importPersonalDoc'), formdata, {
            noEnqueue: true,
            contentType: 'arraybuffer',
            headers: {
                contentType: 'multipart/form-data',
            },
            timeout: 1000 * 60 * 2,
            operator: (handler) => {
                getCancelFn(handler.bind(null, 'abort'));
            },
        })
            .catch((err) => {
            if (typeof err === 'string') {
                throw new Error(err);
            }
            if (err.message && err.message.includes(constHttpCanceledToken)) {
                throw new Error('cancelled');
            }
            throw err;
        });
        const data = res.data;
        return data.data.taskId;
    }
    async checkPersonalConvertTask(taskId) {
        const res = await this.http.get(this.systemApi.getUrl('checkPersonalConvertTask'), { taskId }, {
            noEnqueue: true,
            timeout: 1000 * 60 * 2,
        });
        const data = res.data;
        return data.data;
    }
    getFileURL(task) {
        const type = task.fileType === 'excel' ? 'sheet' : 'doc';
        const host = process.env.BUILD_ISELECTRON ? config('host') : `https://${locationHelper.getHost()}`;
        return `${host}${config('contextPath')}/${type}/#id=${task.fileId}&parentResourceId=${task.dirId}&spaceId=${task.spaceId}&ref=${task.userId}&from=PERSONAL`;
    }
}
const convertApiImpl = new ConvertApiImpl();
api.registerLogicalApi(convertApiImpl);
export default convertApiImpl;
